// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import { ReactSVG } from "react-svg";
import { ColumnsType } from "antd/es/table";
import { Link, useParams } from "react-router-dom";

// Local Imports
import CustomTable from "../../components/custom-table/custom-table";
import Heading from "../../components/heading/heading.component";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import LockImage from "../../assets/lock.svg";
import DocumentVersionService from "./document-version.service";
import KycVersion from "../../models/kyc-version.model";

const DocumentVersions: React.FC = (): ReactElement => {
  const documentVersionService = new DocumentVersionService();
  const { accountId }: { [key: string]: string | undefined } = useParams();
  const [DocumentVersionsData, setDocumentVersionsData] = useState<KycVersion>()

  useEffect(() => {
    fetchDocumentVersionsData()
  }, [])

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Full name",
      dataIndex: "fullName",
      key: "fullName",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      fixed: "left",
    },
    {
      title: "Account type",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },
    {
      title: "Nationality",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
      sorter: (a, b) => a.mobileNumber - b.mobileNumber,
    },
    {
      title: "Version",
      dataIndex: "version",
      key: "version",
      sorter: (a, b) => a.account.length - b.account.length,
      render: (text, record) => (
        <div className="flex flex-col mb-2">
          <Link to={`/customers/change-list/${accountId}/${record?.id}`}>Version {text} </Link>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      filters: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
      ],
      // render: () => <span className="status">Active</span>,
    },
    {
      title: "Approved by",
      dataIndex: "lastLogin",
      key: "lastLogin",
      sorter: (a, b) => a.lastLogin.length - b.lastLogin.length,
    },
    {
      title: "Actions",
      key: "actions",
      width: '150px',
      render: () => (
        <div className="actions flex items-center gap-3 w-16">
          <ReactSVG src={LockImage} />
          <ReactSVG
            className="delete-icon"
            src={"/images/delete.svg"}
          />
        </div>
      ),
    },
  ];

  const fetchDocumentVersionsData = async (): Promise<void> => {
    const data = await documentVersionService.getDocumentVersionsData(
      accountId
    );

    if (data !== undefined) {
      setDocumentVersionsData(data);
    }
  };

  return (
    <div className="flex flex-col">
      <Heading
        text="Document versions"
        size={4}
        className="text-lg font-medium mb-5 text-black-500"
      />
      <BreadcrumbComponent />
      <div className="mt-5 border-t-[1px] border-lightGray-300 rounded-lg">
        <CustomTable columns={columns} data={DocumentVersionsData?.documents} />
      </div>

    </div>
  );
};

export default DocumentVersions;
